//import IntoyouFetch from "@/pcomponents/common/fetch";
import LygFetch from "@/lib/lyg/fetch";
class IntoyouFetch {
  static async send(inData) {
    let opt_obj = {
      method: 'POST',
      url: "",
      headers: {},
      data: {},
      ...inData
    };
    let default_headers = {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      "Authorization":localStorage.intoyou_token
    };
    let headers = {
      ...default_headers,
      ...opt_obj.headers
    };
    opt_obj.headers = headers;
    return await LygFetch.send(opt_obj);
  }
}
export default IntoyouFetch;